import axios from "axios"
import store from "@/store"
import router from "@/router"
import { MessageBox, Loading } from "element-ui"

/**
 * @typedef ApiConfig
 * @property baseURL    string
 * @property filesPath  string
 * @property timeout    number
 */
// const baseURL = process.env.BASE_URL
// const baseURL = `http://10.0.0.192:9090/`
const baseURL = `https://www.realserver.com.cn/quotation/comm/`
// const baseURL = `http://localhost:9090`
const filesPath = `${baseURL}files`
const timeout = 60000

/**
 * @type ApiConfig
 */
export const apiConfig = {
  baseURL,
  filesPath,
  timeout,
}

const service = axios.create({ baseURL, timeout })

// var isalert = 1

// console.log(process.env.BASE_URL)

// let pending = []
// let cancelToken = axios.CancelToken
// let removePending = (config) => {
//   for (let p in pending) {
//     if (pending[p].u === config.url + "&" + config.method) {
//       pending[p].f()
//       pending.splice(p, 1)
//     }
//   }
// }

let loadingInstance = null

function startLoading() {
  loadingInstance = Loading.service({
    fullscreen: true,
    text: "",
    background: "rgba(213,211,211,0.3)",
  })
}

function endLoading() {
  loadingInstance.close()
}

let needLoadingRequestCount = 0

function showFullScreenLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading()
  }
  needLoadingRequestCount++
}

function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    endLoading()
  }
}

service.defaults.withCredentials = true

service.interceptors.request.use(
  (config) => {
    var token = store.state.token
    showFullScreenLoading()
    if (token && config.headers["need-token"]) {
      config.headers["token"] = token
    }
    config.headers["Access-Control-Allow-Origin"] = "*"

    return config
  },
  (error) => {
    // Toast('网络不通!');
    tryHideFullScreenLoading()
    return Promise.reject(error)
  },
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    tryHideFullScreenLoading()
    const res = response.data
    if (res.code == 200 || !res.code) {
      return res
    } else if (
      res.code == 400 ||
      res.code == 403 ||
      res.code == 404 ||
      res.code == 405 ||
      res.code == 406 ||
      res.code == 409 ||
      res.code == 410
    ) {
      MessageBox.alert(res.message)
      return new Promise(function() {})
    } else if (res.code == 411) {
      return res
    } else if (res.code == 401 || res.code == 407 || res.code == 408) {
      MessageBox.confirm(res.message, "请重新登录", {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        router.push({ path: "/login" })
      })
      return new Promise(function() {})
    } else if (!res.code) {
      return res
    } else {
      if (res.data && res.data[0] && res.data[0].errorType == "inventory_not_enough") {
        MessageBox.alert("库存不足")
      } else {
        MessageBox.alert(res.message)
      }
      return new Promise(function() {})
    }
  },
  (error) => {
    tryHideFullScreenLoading()
    MessageBox.alert(error)
    return new Promise(function() {})
  },
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js